import { Accordion } from '@mantine/core';
import axios from 'axios';
import { useEffect, useState } from 'react';
import './PreguntasFrecuentesContainer.css';
import ThinkingDog from '../../assets/FrecuentQuestions/attention.gif';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import ContactCard from '../Contact/ContactCard/ContactCard';
import { useLocation } from 'react-router-dom';

const PreguntasFrecuentesContainer = ({contact, title, description}) => {
  const {subject, message, data, contactTitle, formTitle, form} = contact;
  const { state: courseData } = useLocation();
  const { width } = useWindowDimensions();
  const isMobile = width <= 768;
  const [faqs, setFaqs] = useState([]);
  const [isMount, setIsMount] = useState(true);

  const fetchFaqs = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_SERVER}/info/faqs/landing`
      );
      const formattedResponse = response.data.map((faq) => ({
        name: faq.name,
        question: faq.question,
        id: faq._id,
        answer: faq.answer,
      }));
      setFaqs(formattedResponse);
    } catch (error) {
      console.error("Error fetching FAQs data:", error);
    }
  };

  useEffect(() => {
    if (isMount) {
      setIsMount(false);
    } else {
      fetchFaqs();
    }
  }, [isMount]);

  return (
    <div className='preguntasFrecuentesContainer-father-div'>
      <div className="preguntasFrecuentesContainer-grid">
        {isMobile ? (
          <>
            {faqs.length > 0 && <div className='preguntasFrecuentesContainer-content'>
              <h2 className="preguntasFrecuentesContainer-title">
                {title}
              </h2>
              <Accordion
                classNames={{ label: 'preguntasFrecuentesContainer-accordion-labels', panel: 'preguntasFrecuentesContainer-accordion-panel' }}
                chevronPosition="right"
                variant="separated"
              >
                {faqs.map((faq) => (
                  <Accordion.Item key={faq.id} value={faq.id}>
                    <Accordion.Control>{faq.question}</Accordion.Control>
                    <Accordion.Panel>{faq.answer}</Accordion.Panel>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>}
            <div className='preguntasFrecuentesContainer-contactCard-div'>
              <ContactCard formData={form} contactTitle={contactTitle} formTitle={formTitle} subject={subject} message={message} data={data} />
            </div>
          </>
        ) : (
          <>
            {faqs.length > 0 && 
            <>
            <div className='preguntasFrecuentesContainer-div-image'>
              <img className='preguntasFrecuentesContainer-image' src={ThinkingDog} alt="Frequently Asked Questions" />
            </div>
            <div className='preguntasFrecuentesContainer-content'>
              <h2 className="preguntasFrecuentesContainer-title">
                Preguntas frecuentes
              </h2>
              <Accordion
                classNames={{ label: 'preguntasFrecuentesContainer-accordion-labels', panel: 'preguntasFrecuentesContainer-accordion-panel' }}
                chevronPosition="right"
                variant="separated"
              >
                {faqs.map((faq) => (
                  <Accordion.Item key={faq.id} value={faq.id}>
                    <Accordion.Control>{faq.question}</Accordion.Control>
                    <Accordion.Panel>{faq.answer}</Accordion.Panel>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
            </>
            }
            <div className='preguntasFrecuentesContainer-contactCard-div'>
              <h4 className='preguntasFrecuentesContainer-contactCard-text'>{description}</h4>
              <ContactCard formData={form} contactTitle={contactTitle} formTitle={formTitle} subject={subject} message={message} data={data} courseData={courseData} />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PreguntasFrecuentesContainer;